import { render } from "./05_CustomerSection.vue?vue&type=template&id=39fcda06&scoped=true"
import script from "./05_CustomerSection.vue?vue&type=script&lang=js"
export * from "./05_CustomerSection.vue?vue&type=script&lang=js"

import "./05_CustomerSection.vue?vue&type=style&index=0&id=39fcda06&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39fcda06"]])

export default __exports__